import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// 3rd party
import { TableModule } from 'primeng/table';
// Components
import { DatatableComponent } from './components/datatable.component';
import { ColumnComponent } from './components/column/column.component';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

@NgModule({
    declarations: [
        DatatableComponent,
        ColumnComponent
    ],
    imports: [
        CommonModule,
        TableModule,
		InputTextModule,
        FormsModule,
        ButtonModule
    ],
    exports: [
        DatatableComponent
    ]
})
export class DatatableModule { }
